import { BaseTransaction, Response, apiAbortController } from '@ui/src';
import api from '../../../api/api';
import { PspPartnerItem, IntegrationLog } from '../types';

export const integrationLogsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPspPartnerList: build.query<Response<PspPartnerItem>, void>({
      query: () => ({
        url: `/v1/psp-partners?all=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getIntegrationsLogs: build.query<Response<IntegrationLog>, string>({
      query: (query) => ({
        url: `/v1/psp-integrations-logs${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getIntegrationsLogsById: build.query<{ data: IntegrationLog }, string>({
      query: (logId) => ({
        url: `/v1/psp-integrations-logs/${logId}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getIntegrationLogTransactionById: build.query<
      { data: BaseTransaction },
      string
    >({
      query: (id) => ({
        url: `/v1/transactions/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetIntegrationsLogsQuery,
  useLazyGetPspPartnerListQuery,
  useLazyGetIntegrationsLogsByIdQuery,
  useLazyGetIntegrationLogTransactionByIdQuery,
} = integrationLogsApi;

export const {
  endpoints: {
    getIntegrationsLogs,
    getPspPartnerList,
    getIntegrationsLogsById,
    getIntegrationLogTransactionById,
  },
} = integrationLogsApi;
